import { useRef, useState } from "react";
import { apiClient, createBillingIdempotencyKey } from "@/api/client";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

export default function PaymentMethodCard() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const idempotencyKey = useRef(createBillingIdempotencyKey("payment-method"));

  const handleUpdate = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const { checkout_url } = await apiClient.updatePaymentMethod(
        `${window.location.origin}/billing/payment-method/success`,
        `${window.location.origin}/billing/payment-method/failure`,
        idempotencyKey.current,
      );
      window.location.href = checkout_url;
    } catch (err) {
      console.error("Failed to update payment method", err);
      setError("Failed to start payment method update. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <section className={cn(theme.cards.base, "p-6")}>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Payment Method</h2>
      <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">Manage your payment information</p>
      {error && (
        <div className={cn("mb-4 p-3 rounded-lg text-sm", theme.borders.error, theme.colors.errorBg, theme.text.error)}>
          {error}
        </div>
      )}
      <button
        onClick={handleUpdate}
        disabled={isLoading}
        className={cn(theme.buttons.secondary, "px-6 py-3 rounded-xl", isLoading && "opacity-50 cursor-not-allowed")}
      >
        {isLoading ? "Loading..." : "Update Payment Method"}
      </button>
    </section>
  );
}
